import React from 'react'
import AppModal from '../../components/common/AppModal'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { a11yDark } from 'react-syntax-highlighter/dist/esm/styles/prism'

const ShowMediaBuyPixel = ({ show, onClose, title = 'Preview Code', language = 'javascript', code = () => {} }) => {
    return (
        <AppModal
            show={show}
            title={title}
            onCancel={onClose}
            cancelText="Close"
            hideConfirmButton
        >
            <SyntaxHighlighter
                language={language}
                style={a11yDark}
                customStyle={{
                    fontSize: 'clamp(0.8rem, 1.5vw, 1rem)',
                    padding: '1rem',
                    borderRadius: '8px',
                    background: '#1e1e1e',
                    maxHeight: '70vh',
                    overflowY: 'auto',
                }}
            >
                {code()}
            </SyntaxHighlighter>
        </AppModal>
    )
}

export default ShowMediaBuyPixel
